export default class CalculationStatus {
  static from(data = {}) {
    return new CalculationStatus(data);
  }

  constructor(data = {}) {
    this.pendingRounds = data.pending_rounds || [];
    this.pendingReports = Number(data.pending_reports) || 0;
    this.nextRound = data.next_round || null;
  }

  get fullyComplete() {
    return this.pendingRounds.length === 0 && this.pendingReports === 0;
  }

  get hasPendingRounds() {
    return this.pendingRounds.length > 0;
  }

  get hasNextRoundAsPosition() {
    return (
      this.nextRound?.round_type === "position" && !this.nextRound?.calculated
    );
  }
}
